<template>
  <section>
    <b-table
      :items="enrollmentItems"
      :fields="fields"
      table-class="table-minimal"
      :empty-text="$t('common.noRecordsToShow')"
      show-empty
    >
      <template #cell(value)="data">
        {{ getEnrollmentValue(data.item) }}
      </template>
    </b-table>
  </section>
</template>

<script setup>
import moment from 'moment';
import { computed } from 'vue';
import i18n from '@/i18n';
import { EMPLOYEE_STATE } from '@/utils/Employee';
import { toFormattedDate } from '@/utils/date';

const HISTORY_KEYS = {
  STATUS_CHANGED: 'STATUS_CHANGED',
};

const HISTORY_LABEL_KEYS = {
  [HISTORY_KEYS.STATUS_CHANGED]: 'employee.history.newStatusLabel',
};

const HISTORY_VALUES = {
  [HISTORY_KEYS.STATUS_CHANGED]: item => item.properties.state,
};

const fields = computed(() => [
  {
    key: 'logged_at',
    label: i18n.t('employee.activityLog.columns.dateTime'),
    sortable: true,
    formatter: value => toFormattedDate(value, 'YYYY-MM-DD HH:mm'),
  },
  {
    key: 'activity',
    label: i18n.t('employee.activityLog.columns.action'),
    formatter: value => (HISTORY_LABEL_KEYS[value] ? i18n.t(HISTORY_LABEL_KEYS[value]) : value),
  },
  {
    key: 'value',
    label: '',
  },
]);

const props = defineProps({
  history: {
    type: Object,
    required: true,
  },
});

const enrollmentItems = computed(() => {
  const items = props.history.enrollment
    .filter(item => item.state !== EMPLOYEE_STATE.ENROLLING)
    .map(item => ({
      activity: HISTORY_KEYS.STATUS_CHANGED,
      logged_at: item.created_at,
      properties: { state: item.state },
    }));

  return items.sort((a, b) => moment(b.logged_at).diff(a.logged_at));
});

const getEnrollmentValue = item => {
  const valueFn = HISTORY_VALUES[item.activity];
  return typeof valueFn === 'function' ? valueFn(item) : '';
};
</script>
